//const API_URL = "https://newbackend-535q.onrender.com/api"; // 本地或部署地址
const API_URL = "https://jb.onesico.com/api"; // 本地或部署地址
//const API_URL = "http://localhost:5000/api"; // 本地或部署地址

// 获取技能
export async function getSkills() {
  const res = await fetch(`${API_URL}/skills`, {
    credentials: "include",
  });
  const json = await res.json();

  const formatted = json.data.map((item) => ({
    title: item.name,
    description: item.description,
    imageUrl: item.icon || null, // ✅ 直接用 icon 字段
    level: item.level,
  }));

  return { data: formatted };
}

// 获取项目
export async function getProjects() {
  const res = await fetch(`${API_URL}/projects`, {
    credentials: "include",
  });
  const json = await res.json();

  const formatted = json.data.map((project) => {
    const descriptionParagraphs = project.description
      .split(/\r?\n\r?\n/)
      .filter((text) => text.trim() !== "")
      .map((para) => ({
        children: [{ text: para.trim() }],
      }));

    return {
      id: project._id,
      hometitle: project.homeTitle,
      title: project.title,
      date: project.date,
      description: project.description,
      detail: descriptionParagraphs,
      cover: { url: project.cover || null },
      technologies: project.technologies,
      githubUrl: project.githubUrl,
      liveUrl: project.liveUrl,
      category: project.category,
      featured: project.featured,
      summary: project.summary,
    };
  });

  return { data: formatted };
}

// 获取经历
export async function getExperiences() {
  const res = await fetch(`${API_URL}/experiences`, {
    credentials: "include",
  });
  const json = await res.json();

  const formatted = json.data.map((item) => ({
    _id: item._id,
    title: item.title, // ✅ 应该是 title 不是 name
    company: item.company,
    date: item.date,
    description: item.description,
    location: item.location,
    jobskills: item.skills,
  }));

  return formatted; // ✅ 直接返回数组，而不是 { data: [...] }
}


export async function getEducations() {
  const res = await fetch(`${API_URL}/educations`, {
    credentials: "include",
  });
  const json = await res.json();

  const formatted = json.data.map((item) => ({
    _id: item._id,
    title: item.title, // ✅ 应该是 title 不是 name
    school: item.school,
    date: item.date,
    description: item.description,
    location: item.location,
    relevantcourse: item.skills,
    gpa: item.gpa || null, // GPA 字段可能不存在
  }));

  return formatted; // ✅ 直接返回数组，而不是 { data: [...] }
}